import { AnsweringClient } from "../../clients/answeringClient";
import { describeApiError, isExpiredSession } from "../../utils/apiError";

export interface IAssignment {
  applicationId: number;
  title: string;
  dueDate: Date;
  instrumentTitle: string;
}

export interface ArchiveApplicationModalControllerDelegate {
  didArchiveApplication: () => void;
  didFailArchiveApplication: (message: string) => void;
  applicationShouldLogout: () => void;
}

export class ArchiveApplicationModalController {

  constructor (
    private delegate: ArchiveApplicationModalControllerDelegate,
    private readonly answeringClient = new AnsweringClient()
  ) { }

  public async archiveApplication(
    accessToken: string,
    applicationId: number,
    hasRetried = false
  ): Promise<void> {
    try {
      await this.answeringClient.archiveApplication(accessToken, applicationId);
      this.delegate.didArchiveApplication();
    } catch (error: any) {
      if (isExpiredSession(error) && !hasRetried) {
        const newTokens = await this.refreshTokens();
        if (!newTokens) {
          return;
        }
        return this.archiveApplication(
          newTokens.accessToken,
          applicationId,
          true
        );
      }
      this.delegate.didFailArchiveApplication(
        describeApiError(
          error,
          "Não foi possível arquivar a aplicação. Tente novamente em instantes."
        )
      );
    }
  }

  private async refreshTokens(): Promise<{accessToken: string, refreshToken: string} | void> {
    const refreshToken = localStorage.getItem("RefreshToken");
    if(!refreshToken) {
      this.delegate.applicationShouldLogout();
      return;
    }
    try {
      const response = await this.answeringClient.refreshToken(refreshToken);
      const tokens: {accessToken: string, refreshToken: string} = response.data;
      localStorage.setItem("AccessToken", tokens.accessToken);
      localStorage.setItem("RefreshToken", tokens.refreshToken);
      return tokens;
    } catch (error: any) {
      this.delegate.applicationShouldLogout();
      return;
    } 
  }
}